import JoditEditor from 'jodit-react';
import 'jodit/es2021/jodit.min.css';
import React, { memo, useCallback, useMemo, useRef } from 'react';
import useRefValue from '../hooks/useRefValue';
import './styles/joditEditor.less';

const MemoEditor = memo(
  ({
    disabled,
    className,
    onChange,
    value,
    height = '100%',
    direction = 'ltr',
    editorRef
  }) => {
    const handleBlur = (val) => {
      if (val === '<p><br></p>') onChange('');
      else onChange(val);
    };

    const config = useMemo(
      () => ({
        direction,
        buttons: [
          'paragraph',
          'bold',
          'underline',
          'italic',
          'strikethrough',
          'superscript',
          'subscript',
          'eraser',
          'outdent',
          'indent',
          'align',
          'ol',
          'ul',
          'link',
          'fullsize',
          'source',
          'preview',
          'undo',
          'redo'
        ],
        toolbarAdaptive: false,
        toolbarButtonSize: 'large',
        disabled,
        height,
        allowResizeX: false,
        allowResizeY: false,
        className,
        theme: 'dark',
        showPlaceholder: false
      }),
      [direction, disabled]
    );

    return (
      <JoditEditor
        ref={editorRef}
        config={config}
        value={value}
        onBlur={handleBlur}
      />
    );
  }
);

const HtmlEditor = ({
  value,
  onChange,
  height,
  disabled = false,
  direction = 'ltr'
}) => {
  const editorRef = useRef(null);
  const onChangeRef = useRefValue(onChange);

  const handleChange = useCallback((val) => {
    onChangeRef.current?.(val);
  }, []);

  return (
    <>
      <MemoEditor
        value={value}
        onChange={handleChange}
        height={height}
        disabled={disabled}
        direction={direction}
        editorRef={editorRef}
      />
    </>
  );
};

export default HtmlEditor;
